import type { FloatPoint3D } from '@/shared/api/protocol-ts/model/dto_common_geometry_pb';

import type { ToothSliceVec3 } from '../config';

export const toToothSliceVec3 = (
  point: FloatPoint3D | undefined,
): ToothSliceVec3 | null => {
  if (
    !point ||
    !Number.isFinite(point.X) ||
    !Number.isFinite(point.Y) ||
    !Number.isFinite(point.Z)
  ) {
    return null;
  }

  return { x: point.X, y: point.Y, z: point.Z };
};
